import { render, staticRenderFns } from "./RemoveTag.vue?vue&type=template&id=1cd9f6b0&"
import script from "./RemoveTag.vue?vue&type=script&lang=ts&"
export * from "./RemoveTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports